import { reduce, isNil, find, sum, some } from 'lodash';
import { i18n } from '@lingui/core';

import { DataServiceFactory } from '../../services/ApiDataService';
import { GLOBAL_SEARCH_TYPES } from './Constants';

const dataService = DataServiceFactory();
const URL = '/query/search';

export function getResults(search, params) {
    const { rowLimit = 10, rowStart = 0, type, isPgm, userGroups, cursor } = params || {};
    const offset = isPgm ? { ...(cursor ? { cursor } : {}) } : { rowStart };

    return dataService.get(URL, { search, rowLimit, userGroups, ...offset, ...(type ? { type } : {}) });
}

export function mergeResults(currentResults, newResults) {
    return currentResults.map((currentResult) =>
        mergeResult(currentResult, findMatchingResult(currentResult, newResults))
    );
}

function mergeResult(currentResult, newResult) {
    if (!newResult) {
        return currentResult;
    }

    return {
        ...newResult,
        matches: [...currentResult.matches, ...newResult.matches],
    };
}

function findMatchingResult(needleResult, results) {
    return find(results, { type: needleResult.type });
}

export function isExactMatch(results) {
    return some(results, ({ maxScore }) => maxScore && maxScore > 0);
}

export function getTotalMatches(results) {
    return sum(results?.map(({ total }) => total));
}

export function buildRows(results) {
    return reduce(results, (rows, result) => [...rows, ...buildRowsFromResult(result)], []);
}

function buildRowsFromResult(result) {
    return [buildTitleRow(result), ...buildMatchRows(result), buildShowMoreRow(result)].filter((x) => !isNil(x));
}

function buildTitleRow(result) {
    const { type, total, matches } = result;

    const { title, icon } = GLOBAL_SEARCH_TYPES[type];

    return {
        isHeader: true,
        title: i18n._(title),
        icon,
        type,
        total,
        count: matches.length,
        id: `title-${type}-${matches.length}`,
    };
}

function buildMatchRows(result) {
    const { matches } = result;

    return matches.map((match) => buildMatchRow(result, match));
}

function buildMatchRow(result, match) {
    const { type } = result;

    const { link, filterMapping } = GLOBAL_SEARCH_TYPES[type];

    return {
        isResult: true,
        type,
        link,
        filterMapping,
        ...match,
        id: match.uuid,
    };
}

function buildShowMoreRow(result) {
    const { limit, start, total, type, cursor } = result;

    if (limit + start >= total) {
        return null;
    }

    return {
        isShowMore: true,
        limit,
        start,
        type,
        cursor,
        id: `show-more-${type}`,
    };
}
